<script lang="ts">
	import '../app.css';
	import PageScripts from '$lib/components/PageScripts.svelte';
	import Metadata from '$lib/components/metadata.svelte';
	import * as Tooltip from '$lib/components/ui/tooltip';
	import { ModeWatcher } from 'mode-watcher';
	import { Toaster } from '$lib/components/ui/sonner';
	import '@fontsource/montserrat/latin-400.css';
	import '@fontsource/montserrat/latin-500.css';
	import '@fontsource/montserrat/latin-600.css';
	import '@fontsource/montserrat/latin-700.css';
	import '@fontsource/saira/latin-400.css';
	import '@fontsource/saira/latin-500.css';
	import '@fontsource/saira/latin-600.css';
	import '@fontsource/saira/latin-700.css';
	import '@fontsource/saira/latin-800.css';

	let { children, data } = $props();
</script>

<ModeWatcher defaultMode={data.mode} />
<Metadata />

<Toaster />

<PageScripts />

<Tooltip.Provider>
	<div class="relative flex min-h-screen flex-col bg-background" id="page" data-vaul-drawer-wrapper>
		{@render children?.()}
	</div>
</Tooltip.Provider>
